import { isTrialExpired } from '../../utilis/sguTrial';

export const checkAuth = () => {
  const userData = localStorage.getItem("user");
  const token = localStorage.getItem("token");

  if (!userData || !token) {
    return false;
  }

  const user = JSON.parse(userData);

  if (isTrialExpired(user)) {
    return false;
  }

  const lastLogDate = new Date(user.date);

  const now = new Date();
  const diffTime = now - lastLogDate;

  const sessionTime = 18 * 60 * 60 * 1000;

  if (diffTime > sessionTime) {
    return false;
  }

  return true;
};

export const getToken = () =>
  JSON.parse(localStorage.getItem('user')) != null
    ? JSON.parse(localStorage.getItem('user')).token
    : null;
